module.exports = __webpack_public_path__ + "static/media/icon-alert.750c5e8c.svg";